

// import { useState, useRef } from "react";

// // ── Full Specialities List (Grouped) ─────────────────────────────────────────
// const SPECIALITIES = [
//   // General & Primary Care
//   { name: "General Physician",                  icon: "🩺", category: "General & Primary Care" },
//   { name: "Family Medicine Specialist",          icon: "🩺", category: "General & Primary Care" },
//   { name: "Internal Medicine Specialist",        icon: "🩺", category: "General & Primary Care" },
//   { name: "Preventive Medicine Specialist",      icon: "🩺", category: "General & Primary Care" },
//   { name: "Community Medicine Specialist",       icon: "🩺", category: "General & Primary Care" },
//   { name: "Emergency Medicine Specialist",       icon: "🚨", category: "General & Primary Care" },
//   { name: "Hospitalist",                         icon: "🏥", category: "General & Primary Care" },
//   { name: "Primary Care Physician",              icon: "🩺", category: "General & Primary Care" },

//   // Heart & Blood
//   { name: "Cardiologist",                        icon: "❤️", category: "Heart & Blood" },
//   { name: "Interventional Cardiologist",         icon: "❤️", category: "Heart & Blood" },
//   { name: "Cardiac Electrophysiologist",         icon: "❤️", category: "Heart & Blood" },
//   { name: "Pediatric Cardiologist",              icon: "❤️", category: "Heart & Blood" },
//   { name: "Cardiothoracic Surgeon",              icon: "❤️", category: "Heart & Blood" },
//   { name: "Vascular Surgeon",                    icon: "❤️", category: "Heart & Blood" },
//   { name: "Cardiac Surgeon",                     icon: "❤️", category: "Heart & Blood" },
//   { name: "Heart Failure Specialist",            icon: "❤️", category: "Heart & Blood" },

//   // Brain & Nervous System
//   { name: "Neurologist",                         icon: "🧠", category: "Brain & Nervous System" },
//   { name: "Neurosurgeon",                        icon: "🧠", category: "Brain & Nervous System" },
//   { name: "Pediatric Neurologist",               icon: "🧠", category: "Brain & Nervous System" },
//   { name: "Neurophysiologist",                   icon: "🧠", category: "Brain & Nervous System" },
//   { name: "Stroke Specialist",                   icon: "🧠", category: "Brain & Nervous System" },
//   { name: "Neurocritical Care Specialist",       icon: "🧠", category: "Brain & Nervous System" },
//   { name: "Epileptologist",                      icon: "🧠", category: "Brain & Nervous System" },
//   { name: "Neurointerventional Surgeon",         icon: "🧠", category: "Brain & Nervous System" },
//   { name: "Movement Disorder Specialist",        icon: "🧠", category: "Brain & Nervous System" },
//   { name: "Neuromuscular Specialist",            icon: "🧠", category: "Brain & Nervous System" },
//   { name: "Headache Specialist",                 icon: "🧠", category: "Brain & Nervous System" },
//   { name: "Sleep Neurologist",                   icon: "🧠", category: "Brain & Nervous System" },
//   { name: "Cognitive Neurologist",               icon: "🧠", category: "Brain & Nervous System" },
//   { name: "Pain Neurologist",                    icon: "🧠", category: "Brain & Nervous System" },
//   { name: "Neurorehabilitation Specialist",      icon: "🧠", category: "Brain & Nervous System" },
//   { name: "Functional Neurologist",              icon: "🧠", category: "Brain & Nervous System" },
//   { name: "Brain Injury Specialist",             icon: "🧠", category: "Brain & Nervous System" },
//   { name: "Autonomic Disorder Specialist",       icon: "🧠", category: "Brain & Nervous System" },

//   // Bones & Muscles
//   { name: "Orthopedic Surgeon",                  icon: "🦴", category: "Bones & Muscles" },
//   { name: "Spine Surgeon",                       icon: "🦴", category: "Bones & Muscles" },
//   { name: "Sports Medicine Doctor",              icon: "🦴", category: "Bones & Muscles" },
//   { name: "Joint Replacement Surgeon",           icon: "🦴", category: "Bones & Muscles" },
//   { name: "Hand Surgeon",                        icon: "🦴", category: "Bones & Muscles" },
//   { name: "Orthopedic Trauma Specialist",        icon: "🦴", category: "Bones & Muscles" },
//   { name: "Foot & Ankle Surgeon",               icon: "🦴", category: "Bones & Muscles" },
//   { name: "Pediatric Orthopedic Surgeon",        icon: "🦴", category: "Bones & Muscles" },
//   { name: "Orthopedic Oncologist",               icon: "🦴", category: "Bones & Muscles" },
//   { name: "Shoulder Specialist",                 icon: "🦴", category: "Bones & Muscles" },
//   { name: "Hip Specialist",                      icon: "🦴", category: "Bones & Muscles" },
//   { name: "Orthopedic Spine Specialist",         icon: "🦴", category: "Bones & Muscles" },
//   { name: "Sports Injury Specialist",            icon: "🦴", category: "Bones & Muscles" },
//   { name: "Rheumatologist",                      icon: "🦵", category: "Bones & Muscles" },

//   // Child Health
//   { name: "Pediatrician",                        icon: "👶", category: "Child Health" },
//   { name: "Neonatologist",                       icon: "👶", category: "Child Health" },
//   { name: "Pediatric Surgeon",                   icon: "👶", category: "Child Health" },
//   { name: "Pediatric Endocrinologist",           icon: "👶", category: "Child Health" },
//   { name: "Pediatric Gastroenterologist",        icon: "👶", category: "Child Health" },
//   { name: "Pediatric Hematologist",              icon: "👶", category: "Child Health" },
//   { name: "Pediatric Urologist",                 icon: "👶", category: "Child Health" },
//   { name: "Pediatric ENT Specialist",            icon: "👶", category: "Child Health" },
//   { name: "Pediatric Ophthalmologist",           icon: "👶", category: "Child Health" },
//   { name: "Pediatric Anesthesiologist",          icon: "👶", category: "Child Health" },
//   { name: "Pediatric Radiologist",               icon: "👶", category: "Child Health" },
//   { name: "Child Psychiatrist",                  icon: "👶", category: "Child Health" },
//   { name: "Adolescent Medicine Specialist",      icon: "👶", category: "Child Health" },

//   // Women's Health
//   { name: "Gynecologist",                        icon: "🌸", category: "Women's Health" },
//   { name: "Obstetrician",                        icon: "🌸", category: "Women's Health" },
//   { name: "Maternal-Fetal Medicine Specialist",  icon: "🌸", category: "Women's Health" },
//   { name: "Reproductive Endocrinologist",        icon: "🌸", category: "Women's Health" },
//   { name: "Fertility Specialist",                icon: "🌸", category: "Women's Health" },
//   { name: "Gynecologic Oncologist",              icon: "🌸", category: "Women's Health" },
//   { name: "Urogynecologist",                     icon: "🌸", category: "Women's Health" },
//   { name: "Women's Health Specialist",           icon: "🌸", category: "Women's Health" },
//   { name: "Lactation Medicine Specialist",       icon: "🌸", category: "Women's Health" },

//   // Eye Care
//   { name: "Ophthalmologist",                     icon: "👁️", category: "Eye Care" },
//   { name: "Retina Specialist",                   icon: "👁️", category: "Eye Care" },
//   { name: "Cornea Specialist",                   icon: "👁️", category: "Eye Care" },
//   { name: "Glaucoma Specialist",                 icon: "👁️", category: "Eye Care" },
//   { name: "Oculoplastic Surgeon",                icon: "👁️", category: "Eye Care" },
//   { name: "Neuro-Ophthalmologist",               icon: "👁️", category: "Eye Care" },

//   // Ear, Nose & Throat
//   { name: "ENT Specialist",                      icon: "👂", category: "Ear, Nose & Throat" },
//   { name: "Otologist",                           icon: "👂", category: "Ear, Nose & Throat" },
//   { name: "Rhinologist",                         icon: "👂", category: "Ear, Nose & Throat" },
//   { name: "Laryngologist",                       icon: "👂", category: "Ear, Nose & Throat" },
//   { name: "Head & Neck Surgeon",                icon: "👂", category: "Ear, Nose & Throat" },
//   { name: "Balance Disorder Specialist",         icon: "👂", category: "Ear, Nose & Throat" },
//   { name: "Vestibular Specialist",               icon: "👂", category: "Ear, Nose & Throat" },

//   // Chest & Respiratory
//   { name: "Pulmonologist",                       icon: "🫁", category: "Chest & Respiratory" },
//   { name: "Critical Care Specialist",            icon: "🫁", category: "Chest & Respiratory" },
//   { name: "Sleep Medicine Specialist",           icon: "🫁", category: "Chest & Respiratory" },
//   { name: "Respiratory Medicine Specialist",     icon: "🫁", category: "Chest & Respiratory" },
//   { name: "Pulmonary Hypertension Specialist",   icon: "🫁", category: "Chest & Respiratory" },
//   { name: "Sleep Disorder Specialist",           icon: "🫁", category: "Chest & Respiratory" },

//   // Digestive System
//   { name: "Gastroenterologist",                  icon: "🍽️", category: "Digestive System" },
//   { name: "Hepatologist",                        icon: "🍽️", category: "Digestive System" },
//   { name: "Colorectal Surgeon",                  icon: "🍽️", category: "Digestive System" },
//   { name: "Pancreatic Specialist",               icon: "🍽️", category: "Digestive System" },
//   { name: "Bariatric Surgeon",                   icon: "🍽️", category: "Digestive System" },
//   { name: "Bariatric Medicine Specialist",       icon: "🍽️", category: "Digestive System" },

//   // Hormones & Metabolism
//   { name: "Endocrinologist",                     icon: "⚗️", category: "Hormones & Metabolism" },
//   { name: "Diabetologist",                       icon: "🍬", category: "Hormones & Metabolism" },
//   { name: "Thyroid Specialist",                  icon: "⚗️", category: "Hormones & Metabolism" },
//   { name: "Metabolic Disease Specialist",        icon: "⚗️", category: "Hormones & Metabolism" },
//   { name: "Obesity Medicine Specialist",         icon: "⚗️", category: "Hormones & Metabolism" },

//   // Skin & Cosmetic
//   { name: "Dermatologist",                       icon: "🌿", category: "Skin & Cosmetic" },
//   { name: "Cosmetic Dermatologist",              icon: "🌿", category: "Skin & Cosmetic" },
//   { name: "Plastic Surgeon",                     icon: "🌿", category: "Skin & Cosmetic" },
//   { name: "Aesthetic Medicine Specialist",       icon: "🌿", category: "Skin & Cosmetic" },
//   { name: "Trichologist",                        icon: "🌿", category: "Skin & Cosmetic" },
//   { name: "Dermatopathologist",                  icon: "🌿", category: "Skin & Cosmetic" },
//   { name: "Cosmetic Surgeon",                    icon: "🌿", category: "Skin & Cosmetic" },
//   { name: "Craniofacial Surgeon",                icon: "🌿", category: "Skin & Cosmetic" },

//   // Cancer & Blood
//   { name: "Oncologist",                          icon: "🎗️", category: "Cancer & Blood" },
//   { name: "Radiation Oncologist",                icon: "🎗️", category: "Cancer & Blood" },
//   { name: "Surgical Oncologist",                 icon: "🎗️", category: "Cancer & Blood" },
//   { name: "Hematologist",                        icon: "🎗️", category: "Cancer & Blood" },
//   { name: "Hematologic Oncologist",              icon: "🎗️", category: "Cancer & Blood" },

//   // Mental Health
//   { name: "Psychiatrist",                        icon: "🧘", category: "Mental Health" },
//   { name: "Addiction Medicine Specialist",       icon: "🧘", category: "Mental Health" },
//   { name: "Geriatric Psychiatrist",              icon: "🧘", category: "Mental Health" },
//   { name: "Neuropsychiatrist",                   icon: "🧘", category: "Mental Health" },

//   // Kidney & Urinary
//   { name: "Nephrologist",                        icon: "🔵", category: "Kidney & Urinary" },
//   { name: "Urologist",                           icon: "💧", category: "Kidney & Urinary" },

//   // Diagnostic & Imaging
//   { name: "Pathologist",                         icon: "💊", category: "Diagnostic & Imaging" },
//   { name: "Clinical Pathologist",                icon: "💊", category: "Diagnostic & Imaging" },
//   { name: "Molecular Pathologist",               icon: "💊", category: "Diagnostic & Imaging" },
//   { name: "Radiologist",                         icon: "📡", category: "Diagnostic & Imaging" },
//   { name: "Interventional Radiologist",          icon: "📡", category: "Diagnostic & Imaging" },
//   { name: "Nuclear Medicine Specialist",         icon: "📡", category: "Diagnostic & Imaging" },
//   { name: "Diagnostic Radiologist",              icon: "📡", category: "Diagnostic & Imaging" },
//   { name: "Musculoskeletal Radiologist",         icon: "📡", category: "Diagnostic & Imaging" },
//   { name: "Neuroradiologist",                    icon: "📡", category: "Diagnostic & Imaging" },
//   { name: "Abdominal Radiologist",               icon: "📡", category: "Diagnostic & Imaging" },
//   { name: "Thoracic Radiologist",                icon: "📡", category: "Diagnostic & Imaging" },
//   { name: "Interventional Neuroradiologist",     icon: "📡", category: "Diagnostic & Imaging" },

//   // Surgical Specialties
//   { name: "General Surgeon",                     icon: "🔧", category: "Surgical Specialties" },
//   { name: "Laparoscopic Surgeon",                icon: "🔧", category: "Surgical Specialties" },
//   { name: "Trauma Surgeon",                      icon: "🔧", category: "Surgical Specialties" },
//   { name: "Transplant Surgeon",                  icon: "🔧", category: "Surgical Specialties" },
//   { name: "Endocrine Surgeon",                   icon: "🔧", category: "Surgical Specialties" },
//   { name: "Hepatobiliary Surgeon",               icon: "🔧", category: "Surgical Specialties" },
//   { name: "Burn Specialist",                     icon: "🔧", category: "Surgical Specialties" },

//   // Anesthesia & Pain
//   { name: "Anesthesiologist",                    icon: "💉", category: "Anesthesia & Pain" },
//   { name: "Pain Management Specialist",          icon: "💉", category: "Anesthesia & Pain" },
//   { name: "Pain Medicine Specialist",            icon: "💉", category: "Anesthesia & Pain" },
//   { name: "Cardiac Anesthesiologist",            icon: "💉", category: "Anesthesia & Pain" },
//   { name: "Neuroanesthesiologist",               icon: "💉", category: "Anesthesia & Pain" },
//   { name: "Critical Care Anesthesiologist",      icon: "💉", category: "Anesthesia & Pain" },
//   { name: "Pain Rehabilitation Specialist",      icon: "💉", category: "Anesthesia & Pain" },

//   // Rehabilitation & Therapy
//   { name: "Physical Medicine & Rehabilitation Specialist", icon: "🤸", category: "Rehabilitation & Therapy" },
//   { name: "Physiotherapist",                     icon: "🤸", category: "Rehabilitation & Therapy" },
//   { name: "Occupational Therapist",              icon: "🤸", category: "Rehabilitation & Therapy" },
//   { name: "Speech Therapist",                    icon: "🤸", category: "Rehabilitation & Therapy" },
//   { name: "Rehabilitation Medicine Specialist",  icon: "🤸", category: "Rehabilitation & Therapy" },

//   // Geriatric & Special Care
//   { name: "Geriatrician",                        icon: "👴", category: "Geriatric & Special Care" },
//   { name: "Palliative Care Specialist",          icon: "👴", category: "Geriatric & Special Care" },
//   { name: "Hospice Care Specialist",             icon: "👴", category: "Geriatric & Special Care" },
//   { name: "Long-Term Care Specialist",           icon: "👴", category: "Geriatric & Special Care" },

//   // Immunology & Allergy
//   { name: "Immunologist",                        icon: "🧬", category: "Immunology & Allergy" },
//   { name: "Allergist",                           icon: "🧬", category: "Immunology & Allergy" },
//   { name: "Clinical Immunologist",               icon: "🧬", category: "Immunology & Allergy" },
//   { name: "Transfusion Medicine Specialist",     icon: "🧬", category: "Immunology & Allergy" },

//   // Genetics & Molecular Medicine
//   { name: "Medical Geneticist",                  icon: "🧬", category: "Genetics & Molecular Medicine" },
//   { name: "Cytogeneticist",                      icon: "🧬", category: "Genetics & Molecular Medicine" },
//   { name: "Molecular Geneticist",                icon: "🧬", category: "Genetics & Molecular Medicine" },
//   { name: "Genomic Medicine Specialist",         icon: "🧬", category: "Genetics & Molecular Medicine" },
//   { name: "Genetic Counseling Specialist",       icon: "🧬", category: "Genetics & Molecular Medicine" },
//   { name: "Precision Medicine Specialist",       icon: "🧬", category: "Genetics & Molecular Medicine" },
//   { name: "Regenerative Medicine Specialist",    icon: "🧬", category: "Genetics & Molecular Medicine" },
//   { name: "Stem Cell Therapy Specialist",        icon: "🧬", category: "Genetics & Molecular Medicine" },

//   // Lab & Research Medicine
//   { name: "Clinical Microbiologist",             icon: "🧪", category: "Lab & Research Medicine" },
//   { name: "Virologist",                          icon: "🧪", category: "Lab & Research Medicine" },
//   { name: "Parasitologist",                      icon: "🧪", category: "Lab & Research Medicine" },
//   { name: "Bacteriologist",                      icon: "🧪", category: "Lab & Research Medicine" },
//   { name: "Clinical Pharmacologist",             icon: "🧪", category: "Lab & Research Medicine" },
//   { name: "Toxicologist",                        icon: "🧪", category: "Lab & Research Medicine" },

//   // Public Health
//   { name: "Epidemiologist",                      icon: "🌍", category: "Public Health" },
//   { name: "Public Health Specialist",            icon: "🌍", category: "Public Health" },
//   { name: "Tropical Medicine Specialist",        icon: "🌍", category: "Public Health" },
//   { name: "Global Health Specialist",            icon: "🌍", category: "Public Health" },

//   // Men's & Sexual Health
//   { name: "Men's Health Specialist",             icon: "🧑", category: "Men's & Sexual Health" },
//   { name: "Sexual Health Specialist",            icon: "🧑", category: "Men's & Sexual Health" },
//   { name: "Reproductive Medicine Specialist",    icon: "🧑", category: "Men's & Sexual Health" },

//   // Nutrition & Lifestyle
//   { name: "Clinical Nutritionist",               icon: "🥗", category: "Nutrition & Lifestyle" },
//   { name: "Nutrition Medicine Specialist",       icon: "🥗", category: "Nutrition & Lifestyle" },
//   { name: "Lifestyle Medicine Specialist",       icon: "🥗", category: "Nutrition & Lifestyle" },
//   { name: "Integrative Medicine Specialist",     icon: "🥗", category: "Nutrition & Lifestyle" },
//   { name: "Functional Medicine Specialist",      icon: "🥗", category: "Nutrition & Lifestyle" },

//   // Specialised Medicine
//   { name: "Forensic Medicine Specialist",        icon: "⚕️", category: "Specialised Medicine" },
//   { name: "Aviation Medicine Specialist",        icon: "⚕️", category: "Specialised Medicine" },
//   { name: "Aerospace Medicine Specialist",       icon: "⚕️", category: "Specialised Medicine" },
//   { name: "Diving Medicine Specialist",          icon: "⚕️", category: "Specialised Medicine" },
//   { name: "Hyperbaric Medicine Specialist",      icon: "⚕️", category: "Specialised Medicine" },
//   { name: "Wilderness Medicine Specialist",      icon: "⚕️", category: "Specialised Medicine" },
//   { name: "Military Medicine Specialist",        icon: "⚕️", category: "Specialised Medicine" },
//   { name: "Disaster Medicine Specialist",        icon: "⚕️", category: "Specialised Medicine" },
//   { name: "Space Medicine Specialist",           icon: "⚕️", category: "Specialised Medicine" },
//   { name: "Environmental Medicine Specialist",   icon: "⚕️", category: "Specialised Medicine" },
//   { name: "Occupational Medicine Specialist",    icon: "⚕️", category: "Specialised Medicine" },
//   { name: "Travel Medicine Specialist",          icon: "⚕️", category: "Specialised Medicine" },
//   { name: "Trauma Medicine Specialist",          icon: "⚕️", category: "Specialised Medicine" },

//   // Emerging Fields
//   { name: "Telemedicine Specialist",             icon: "🌐", category: "Emerging Fields" },

//   // Traditional Medicine
//   { name: "Ayurveda",                            icon: "🌿", category: "Traditional Medicine" },
//   { name: "Homeopathy",                          icon: "💊", category: "Traditional Medicine" },

//   // Dentistry
//   { name: "Dentist",                             icon: "🦷", category: "Dentistry" },
// ];

// // ── Category display config ───────────────────────────────────────────────────
// const CATEGORY_ORDER = [
//   "General & Primary Care", "Heart & Blood", "Brain & Nervous System",
//   "Bones & Muscles", "Child Health", "Women's Health", "Eye Care",
//   "Ear, Nose & Throat", "Chest & Respiratory", "Digestive System",
//   "Hormones & Metabolism", "Skin & Cosmetic", "Cancer & Blood",
//   "Mental Health", "Kidney & Urinary", "Diagnostic & Imaging",
//   "Surgical Specialties", "Anesthesia & Pain", "Rehabilitation & Therapy",
//   "Geriatric & Special Care", "Immunology & Allergy",
//   "Genetics & Molecular Medicine", "Lab & Research Medicine",
//   "Public Health", "Men's & Sexual Health", "Nutrition & Lifestyle",
//   "Specialised Medicine", "Emerging Fields", "Traditional Medicine", "Dentistry",
// ];

// const CATEGORY_ICONS = {
//   "General & Primary Care":        "🩺",
//   "Heart & Blood":                 "❤️",
//   "Brain & Nervous System":        "🧠",
//   "Bones & Muscles":               "🦴",
//   "Child Health":                  "👶",
//   "Women's Health":                "🌸",
//   "Eye Care":                      "👁️",
//   "Ear, Nose & Throat":            "👂",
//   "Chest & Respiratory":           "🫁",
//   "Digestive System":              "🍽️",
//   "Hormones & Metabolism":         "⚗️",
//   "Skin & Cosmetic":               "🌿",
//   "Cancer & Blood":                "🎗️",
//   "Mental Health":                 "🧘",
//   "Kidney & Urinary":              "💧",
//   "Diagnostic & Imaging":          "📡",
//   "Surgical Specialties":          "🔧",
//   "Anesthesia & Pain":             "💉",
//   "Rehabilitation & Therapy":      "🤸",
//   "Geriatric & Special Care":      "👴",
//   "Immunology & Allergy":          "🧬",
//   "Genetics & Molecular Medicine": "🧬",
//   "Lab & Research Medicine":       "🧪",
//   "Public Health":                 "🌍",
//   "Men's & Sexual Health":         "🧑",
//   "Nutrition & Lifestyle":         "🥗",
//   "Specialised Medicine":          "⚕️",
//   "Emerging Fields":               "🌐",
//   "Traditional Medicine":          "🌿",
//   "Dentistry":                     "🦷",
// };

// // ── Chip ──────────────────────────────────────────────────────────────────────
// function Chip({ icon, name, onClick }) {
//   const [hovered, setHovered] = useState(false);
//   return (
//     <button
//       onMouseDown={(e) => e.preventDefault()}
//       onClick={onClick}
//       onMouseEnter={() => setHovered(true)}
//       onMouseLeave={() => setHovered(false)}
//       style={{
//         display: "inline-flex", alignItems: "center", gap: "5px",
//         padding: "5px 13px",
//         background: hovered ? "#0ea5e9" : "#f0f9ff",
//         border: `1.5px solid ${hovered ? "#0ea5e9" : "#bae6fd"}`,
//         borderRadius: "20px",
//         fontSize: "12.5px", fontWeight: "700",
//         color: hovered ? "#fff" : "#0369a1",
//         fontFamily: "'Nunito', 'Segoe UI', sans-serif",
//         cursor: "pointer", whiteSpace: "nowrap",
//         transition: "all 0.15s ease",
//         outline: "none", flexShrink: 0,
//       }}
//     >
//       <span style={{ fontSize: "13px", lineHeight: 1 }}>{icon}</span>
//       {name}
//     </button>
//   );
// }

// // ── Dropdown content (shared) ─────────────────────────────────────────────────
// function DropdownContent({ query, onChipClick }) {
//   // Searching: flat filtered list
//   if (query.length > 0) {
//     const matches = SPECIALITIES.filter((s) =>
//       s.name.toLowerCase().includes(query) ||
//       s.category.toLowerCase().includes(query)
//     );
//     return (
//       <>
//         <p style={labelStyle}>
//           {matches.length} matching specialit{matches.length === 1 ? "y" : "ies"}
//         </p>
//         {matches.length > 0 ? (
//           <div style={{ display: "flex", flexWrap: "wrap", gap: "7px" }}>
//             {matches.map((s) => (
//               <Chip key={s.name} icon={s.icon} name={s.name} onClick={() => onChipClick(s.name)} />
//             ))}
//           </div>
//         ) : (
//           <p style={{ fontSize: 12, color: "#9CA3AF", margin: 0 }}>No matching speciality found</p>
//         )}
//       </>
//     );
//   }

//   // Not searching: grouped by category
//   return (
//     <>
//       <p style={labelStyle}>Browse by speciality</p>
//       <div style={{ display: "flex", flexDirection: "column", gap: "14px" }}>
//         {CATEGORY_ORDER.map((cat) => {
//           const items = SPECIALITIES.filter((s) => s.category === cat);
//           if (!items.length) return null;
//           return (
//             <div key={cat}>
//               <p style={catLabelStyle}>
//                 {CATEGORY_ICONS[cat]} {cat}
//               </p>
//               <div style={{ display: "flex", flexWrap: "wrap", gap: "6px" }}>
//                 {items.map((s) => (
//                   <Chip key={s.name} icon={s.icon} name={s.name} onClick={() => onChipClick(s.name)} />
//                 ))}
//               </div>
//             </div>
//           );
//         })}
//       </div>
//     </>
//   );
// }

// const labelStyle = {
//   margin: "0 0 8px 2px", fontSize: "10px", fontWeight: "800",
//   color: "#94a3b8", letterSpacing: "0.7px", textTransform: "uppercase",
//   fontFamily: "'Nunito', sans-serif",
// };

// const catLabelStyle = {
//   margin: "0 0 6px 0", fontSize: "11px", fontWeight: "800",
//   color: "#0369a1", letterSpacing: "0.4px",
//   fontFamily: "'Nunito', sans-serif",
// };

// // ── Universal SpecialityAutosuggest ───────────────────────────────────────────
// //
// //  MODE A — Form Field (Register.jsx) — no `onSelect` prop
// //    <SpecialityAutosuggest
// //      value={doctorData.Speciality}
// //      onChange={(val) => setDoctorData(prev => ({ ...prev, Speciality: val }))}
// //    />
// //    onChange → receives plain STRING
// //    Renders with label, styled border input
// //
// //  MODE B — Search Bar — has `onSelect` prop
// //    <SpecialityAutosuggest
// //      value={searchQuery}
// //      onChange={handleChangeEvent}        ← receives DOM event
// //      onSelect={(name) => ...}            ← chip click
// //      onSearch={() => doSearch()}         ← Enter key
// //      placeholder="Search..."
// //    />
// //    onChange → receives DOM event (e.target.value)
// //    Renders as transparent inline input, no label
// // ─────────────────────────────────────────────────────────────────────────────
// export default function SpecialityAutosuggest({ value, onChange, onSelect, onSearch, placeholder }) {
//   const [focused, setFocused] = useState(false);
//   const inputRef = useRef(null);

//   const isSearchBar = typeof onSelect === "function";
//   const safeValue   = typeof value === "string" ? value : String(value ?? "");
//   const query       = safeValue.trim().toLowerCase();

//   const handleInputChange = (e) => {
//     isSearchBar ? onChange(e) : onChange(e.target.value);
//   };

//   const handleChipClick = (name) => {
//     isSearchBar ? onSelect(name) : onChange(name);
//     inputRef.current?.focus();
//   };

//   const handleKeyDown = (e) => {
//     if (e.key === "Enter")  { e.preventDefault(); setFocused(false); inputRef.current?.blur(); onSearch?.(); }
//     if (e.key === "Escape") { setFocused(false); inputRef.current?.blur(); }
//   };

//   const Dropdown = () => (
//     <div
//       onMouseDown={(e) => e.preventDefault()}
//       style={{
//         position: "absolute",
//         top: isSearchBar ? "calc(100% + 12px)" : "calc(100% + 4px)",
//         left: isSearchBar ? "-14px" : 0,
//         right: isSearchBar ? "-14px" : 0,
//         zIndex: 9999,
//         background: "white",
//         border: "1.5px solid #bae6fd",
//         borderRadius: 12,
//         padding: "12px",
//         boxShadow: "0 8px 32px rgba(0,0,0,0.14)",
//         maxHeight: 340,
//         overflowY: "auto",
//       }}
//     >
//       <DropdownContent query={query} onChipClick={handleChipClick} />
//     </div>
//   );

//   // ── MODE A: Form Field ─────────────────────────────────────────────────────
//   if (!isSearchBar) {
//     return (
//       <div style={{ marginBottom: 14, position: "relative" }}>
//         <label style={{ display: "block", fontSize: 13, fontWeight: 600, color: "#374151", marginBottom: 6 }}>
//           Speciality <span style={{ color: "#EF4444" }}>*</span>
//         </label>
//         <input
//           ref={inputRef}
//           type="text"
//           value={safeValue}
//           onChange={handleInputChange}
//           onFocus={(e) => {
//             setFocused(true);
//             e.target.style.borderColor = "#06B6D4";
//             e.target.style.boxShadow = "0 0 0 3px rgba(6,182,212,0.15)";
//           }}
//           onBlur={(e) => {
//             setTimeout(() => setFocused(false), 180);
//             e.target.style.borderColor = "#E5E7EB";
//             e.target.style.boxShadow = "none";
//           }}
//           onKeyDown={handleKeyDown}
//           placeholder={placeholder || "Type or pick a speciality"}
//           autoComplete="off"
//           style={{
//             width: "100%", padding: "12px 14px",
//             border: "2px solid #E5E7EB", borderRadius: 9,
//             fontSize: 16, outline: "none",
//             transition: "border-color 0.2s, box-shadow 0.2s",
//             WebkitAppearance: "none", boxSizing: "border-box",
//           }}
//         />
//         {focused && <Dropdown />}
//       </div>
//     );
//   }

//   // ── MODE B: Search Bar ─────────────────────────────────────────────────────
//   return (
//     <div style={{ flex: 1, minWidth: 0, position: "relative", alignSelf: "stretch", display: "flex", alignItems: "center" }}>
//       <input
//         ref={inputRef}
//         type="text"
//         value={safeValue}
//         onChange={handleInputChange}
//         onFocus={() => setFocused(true)}
//         onBlur={() => setTimeout(() => setFocused(false), 180)}
//         onKeyDown={handleKeyDown}
//         placeholder={placeholder || "Search by doctor name, clinic, speciality or address..."}
//         autoComplete="off"
//         style={{
//           flex: 1, width: "100%", minWidth: 0,
//           height: "42px", border: "none", background: "transparent",
//           outline: "none", fontSize: "14px",
//           fontFamily: "'Nunito', 'Segoe UI', sans-serif",
//           color: "#0c4a6e", fontWeight: "600",
//           padding: "0 8px", boxSizing: "border-box",
//         }}
//       />
//       {focused && <Dropdown />}
//     </div>
//   );
// }

import { useState, useRef } from "react";

// ── Full Specialities List (Grouped) ─────────────────────────────────────────
const SPECIALITIES = [
  // General & Primary Care
  { name: "General Physician",                  icon: "🩺", category: "General & Primary Care" },
  { name: "Family Medicine Specialist",          icon: "🩺", category: "General & Primary Care" },
  { name: "Internal Medicine Specialist",        icon: "🩺", category: "General & Primary Care" },
  { name: "Preventive Medicine Specialist",      icon: "🩺", category: "General & Primary Care" },
  { name: "Community Medicine Specialist",       icon: "🩺", category: "General & Primary Care" },
  { name: "Emergency Medicine Specialist",       icon: "🚨", category: "General & Primary Care" },
  { name: "Hospitalist",                         icon: "🏥", category: "General & Primary Care" },
  { name: "Primary Care Physician",              icon: "🩺", category: "General & Primary Care" },

  // Heart & Blood
  { name: "Cardiologist",                        icon: "❤️", category: "Heart & Blood" },
  { name: "Interventional Cardiologist",         icon: "❤️", category: "Heart & Blood" },
  { name: "Cardiac Electrophysiologist",         icon: "❤️", category: "Heart & Blood" },
  { name: "Pediatric Cardiologist",              icon: "❤️", category: "Heart & Blood" },
  { name: "Cardiothoracic Surgeon",              icon: "❤️", category: "Heart & Blood" },
  { name: "Vascular Surgeon",                    icon: "❤️", category: "Heart & Blood" },
  { name: "Cardiac Surgeon",                     icon: "❤️", category: "Heart & Blood" },
  { name: "Heart Failure Specialist",            icon: "❤️", category: "Heart & Blood" },

  // Brain & Nervous System
  { name: "Neurologist",                         icon: "🧠", category: "Brain & Nervous System" },
  { name: "Neurosurgeon",                        icon: "🧠", category: "Brain & Nervous System" },
  { name: "Pediatric Neurologist",               icon: "🧠", category: "Brain & Nervous System" },
  { name: "Neurophysiologist",                   icon: "🧠", category: "Brain & Nervous System" },
  { name: "Stroke Specialist",                   icon: "🧠", category: "Brain & Nervous System" },
  { name: "Neurocritical Care Specialist",       icon: "🧠", category: "Brain & Nervous System" },
  { name: "Epileptologist",                      icon: "🧠", category: "Brain & Nervous System" },
  { name: "Neurointerventional Surgeon",         icon: "🧠", category: "Brain & Nervous System" },
  { name: "Movement Disorder Specialist",        icon: "🧠", category: "Brain & Nervous System" },
  { name: "Neuromuscular Specialist",            icon: "🧠", category: "Brain & Nervous System" },
  { name: "Headache Specialist",                 icon: "🧠", category: "Brain & Nervous System" },
  { name: "Sleep Neurologist",                   icon: "🧠", category: "Brain & Nervous System" },
  { name: "Cognitive Neurologist",               icon: "🧠", category: "Brain & Nervous System" },
  { name: "Pain Neurologist",                    icon: "🧠", category: "Brain & Nervous System" },
  { name: "Neurorehabilitation Specialist",      icon: "🧠", category: "Brain & Nervous System" },
  { name: "Functional Neurologist",              icon: "🧠", category: "Brain & Nervous System" },
  { name: "Brain Injury Specialist",             icon: "🧠", category: "Brain & Nervous System" },
  { name: "Autonomic Disorder Specialist",       icon: "🧠", category: "Brain & Nervous System" },

  // Bones & Muscles
  { name: "Orthopedic Surgeon",                  icon: "🦴", category: "Bones & Muscles" },
  { name: "Spine Surgeon",                       icon: "🦴", category: "Bones & Muscles" },
  { name: "Sports Medicine Doctor",              icon: "🦴", category: "Bones & Muscles" },
  { name: "Joint Replacement Surgeon",           icon: "🦴", category: "Bones & Muscles" },
  { name: "Hand Surgeon",                        icon: "🦴", category: "Bones & Muscles" },
  { name: "Orthopedic Trauma Specialist",        icon: "🦴", category: "Bones & Muscles" },
  { name: "Foot & Ankle Surgeon",               icon: "🦴", category: "Bones & Muscles" },
  { name: "Pediatric Orthopedic Surgeon",        icon: "🦴", category: "Bones & Muscles" },
  { name: "Orthopedic Oncologist",               icon: "🦴", category: "Bones & Muscles" },
  { name: "Shoulder Specialist",                 icon: "🦴", category: "Bones & Muscles" },
  { name: "Hip Specialist",                      icon: "🦴", category: "Bones & Muscles" },
  { name: "Orthopedic Spine Specialist",         icon: "🦴", category: "Bones & Muscles" },
  { name: "Sports Injury Specialist",            icon: "🦴", category: "Bones & Muscles" },
  { name: "Rheumatologist",                      icon: "🦵", category: "Bones & Muscles" },

  // Child Health
  { name: "Pediatrician",                        icon: "👶", category: "Child Health" },
  { name: "Neonatologist",                       icon: "👶", category: "Child Health" },
  { name: "Pediatric Surgeon",                   icon: "👶", category: "Child Health" },
  { name: "Pediatric Endocrinologist",           icon: "👶", category: "Child Health" },
  { name: "Pediatric Gastroenterologist",        icon: "👶", category: "Child Health" },
  { name: "Pediatric Hematologist",              icon: "👶", category: "Child Health" },
  { name: "Pediatric Urologist",                 icon: "👶", category: "Child Health" },
  { name: "Pediatric ENT Specialist",            icon: "👶", category: "Child Health" },
  { name: "Pediatric Ophthalmologist",           icon: "👶", category: "Child Health" },
  { name: "Pediatric Anesthesiologist",          icon: "👶", category: "Child Health" },
  { name: "Pediatric Radiologist",               icon: "👶", category: "Child Health" },
  { name: "Child Psychiatrist",                  icon: "👶", category: "Child Health" },
  { name: "Adolescent Medicine Specialist",      icon: "👶", category: "Child Health" },

  // Women's Health
  { name: "Gynecologist",                        icon: "🌸", category: "Women's Health" },
  { name: "Obstetrician",                        icon: "🌸", category: "Women's Health" },
  { name: "Maternal-Fetal Medicine Specialist",  icon: "🌸", category: "Women's Health" },
  { name: "Reproductive Endocrinologist",        icon: "🌸", category: "Women's Health" },
  { name: "Fertility Specialist",                icon: "🌸", category: "Women's Health" },
  { name: "Gynecologic Oncologist",              icon: "🌸", category: "Women's Health" },
  { name: "Urogynecologist",                     icon: "🌸", category: "Women's Health" },
  { name: "Women's Health Specialist",           icon: "🌸", category: "Women's Health" },
  { name: "Lactation Medicine Specialist",       icon: "🌸", category: "Women's Health" },

  // Eye Care
  { name: "Ophthalmologist",                     icon: "👁️", category: "Eye Care" },
  { name: "Retina Specialist",                   icon: "👁️", category: "Eye Care" },
  { name: "Cornea Specialist",                   icon: "👁️", category: "Eye Care" },
  { name: "Glaucoma Specialist",                 icon: "👁️", category: "Eye Care" },
  { name: "Oculoplastic Surgeon",                icon: "👁️", category: "Eye Care" },
  { name: "Neuro-Ophthalmologist",               icon: "👁️", category: "Eye Care" },

  // Ear, Nose & Throat
  { name: "ENT Specialist",                      icon: "👂", category: "Ear, Nose & Throat" },
  { name: "Otologist",                           icon: "👂", category: "Ear, Nose & Throat" },
  { name: "Rhinologist",                         icon: "👂", category: "Ear, Nose & Throat" },
  { name: "Laryngologist",                       icon: "👂", category: "Ear, Nose & Throat" },
  { name: "Head & Neck Surgeon",                icon: "👂", category: "Ear, Nose & Throat" },
  { name: "Balance Disorder Specialist",         icon: "👂", category: "Ear, Nose & Throat" },
  { name: "Vestibular Specialist",               icon: "👂", category: "Ear, Nose & Throat" },

  // Chest & Respiratory
  { name: "Pulmonologist",                       icon: "🫁", category: "Chest & Respiratory" },
  { name: "Critical Care Specialist",            icon: "🫁", category: "Chest & Respiratory" },
  { name: "Sleep Medicine Specialist",           icon: "🫁", category: "Chest & Respiratory" },
  { name: "Respiratory Medicine Specialist",     icon: "🫁", category: "Chest & Respiratory" },
  { name: "Pulmonary Hypertension Specialist",   icon: "🫁", category: "Chest & Respiratory" },
  { name: "Sleep Disorder Specialist",           icon: "🫁", category: "Chest & Respiratory" },

  // Digestive System
  { name: "Gastroenterologist",                  icon: "🍽️", category: "Digestive System" },
  { name: "Hepatologist",                        icon: "🍽️", category: "Digestive System" },
  { name: "Colorectal Surgeon",                  icon: "🍽️", category: "Digestive System" },
  { name: "Pancreatic Specialist",               icon: "🍽️", category: "Digestive System" },
  { name: "Bariatric Surgeon",                   icon: "🍽️", category: "Digestive System" },
  { name: "Bariatric Medicine Specialist",       icon: "🍽️", category: "Digestive System" },

  // Hormones & Metabolism
  { name: "Endocrinologist",                     icon: "⚗️", category: "Hormones & Metabolism" },
  { name: "Diabetologist",                       icon: "🍬", category: "Hormones & Metabolism" },
  { name: "Thyroid Specialist",                  icon: "⚗️", category: "Hormones & Metabolism" },
  { name: "Metabolic Disease Specialist",        icon: "⚗️", category: "Hormones & Metabolism" },
  { name: "Obesity Medicine Specialist",         icon: "⚗️", category: "Hormones & Metabolism" },

  // Skin & Cosmetic
  { name: "Dermatologist",                       icon: "🌿", category: "Skin & Cosmetic" },
  { name: "Cosmetic Dermatologist",              icon: "🌿", category: "Skin & Cosmetic" },
  { name: "Plastic Surgeon",                     icon: "🌿", category: "Skin & Cosmetic" },
  { name: "Aesthetic Medicine Specialist",       icon: "🌿", category: "Skin & Cosmetic" },
  { name: "Trichologist",                        icon: "🌿", category: "Skin & Cosmetic" },
  { name: "Dermatopathologist",                  icon: "🌿", category: "Skin & Cosmetic" },
  { name: "Cosmetic Surgeon",                    icon: "🌿", category: "Skin & Cosmetic" },
  { name: "Craniofacial Surgeon",                icon: "🌿", category: "Skin & Cosmetic" },

  // Cancer & Blood
  { name: "Oncologist",                          icon: "🎗️", category: "Cancer & Blood" },
  { name: "Radiation Oncologist",                icon: "🎗️", category: "Cancer & Blood" },
  { name: "Surgical Oncologist",                 icon: "🎗️", category: "Cancer & Blood" },
  { name: "Hematologist",                        icon: "🎗️", category: "Cancer & Blood" },
  { name: "Hematologic Oncologist",              icon: "🎗️", category: "Cancer & Blood" },

  // Mental Health
  { name: "Psychiatrist",                        icon: "🧘", category: "Mental Health" },
  { name: "Addiction Medicine Specialist",       icon: "🧘", category: "Mental Health" },
  { name: "Geriatric Psychiatrist",              icon: "🧘", category: "Mental Health" },
  { name: "Neuropsychiatrist",                   icon: "🧘", category: "Mental Health" },

  // Kidney & Urinary
  { name: "Nephrologist",                        icon: "🔵", category: "Kidney & Urinary" },
  { name: "Urologist",                           icon: "💧", category: "Kidney & Urinary" },

  // Diagnostic & Imaging
  { name: "Pathologist",                         icon: "💊", category: "Diagnostic & Imaging" },
  { name: "Clinical Pathologist",                icon: "💊", category: "Diagnostic & Imaging" },
  { name: "Molecular Pathologist",               icon: "💊", category: "Diagnostic & Imaging" },
  { name: "Radiologist",                         icon: "📡", category: "Diagnostic & Imaging" },
  { name: "Interventional Radiologist",          icon: "📡", category: "Diagnostic & Imaging" },
  { name: "Nuclear Medicine Specialist",         icon: "📡", category: "Diagnostic & Imaging" },
  { name: "Diagnostic Radiologist",              icon: "📡", category: "Diagnostic & Imaging" },
  { name: "Musculoskeletal Radiologist",         icon: "📡", category: "Diagnostic & Imaging" },
  { name: "Neuroradiologist",                    icon: "📡", category: "Diagnostic & Imaging" },
  { name: "Abdominal Radiologist",               icon: "📡", category: "Diagnostic & Imaging" },
  { name: "Thoracic Radiologist",                icon: "📡", category: "Diagnostic & Imaging" },
  { name: "Interventional Neuroradiologist",     icon: "📡", category: "Diagnostic & Imaging" },

  // Surgical Specialties
  { name: "General Surgeon",                     icon: "🔧", category: "Surgical Specialties" },
  { name: "Laparoscopic Surgeon",                icon: "🔧", category: "Surgical Specialties" },
  { name: "Trauma Surgeon",                      icon: "🔧", category: "Surgical Specialties" },
  { name: "Transplant Surgeon",                  icon: "🔧", category: "Surgical Specialties" },
  { name: "Endocrine Surgeon",                   icon: "🔧", category: "Surgical Specialties" },
  { name: "Hepatobiliary Surgeon",               icon: "🔧", category: "Surgical Specialties" },
  { name: "Burn Specialist",                     icon: "🔧", category: "Surgical Specialties" },

  // Anesthesia & Pain
  { name: "Anesthesiologist",                    icon: "💉", category: "Anesthesia & Pain" },
  { name: "Pain Management Specialist",          icon: "💉", category: "Anesthesia & Pain" },
  { name: "Pain Medicine Specialist",            icon: "💉", category: "Anesthesia & Pain" },
  { name: "Cardiac Anesthesiologist",            icon: "💉", category: "Anesthesia & Pain" },
  { name: "Neuroanesthesiologist",               icon: "💉", category: "Anesthesia & Pain" },
  { name: "Critical Care Anesthesiologist",      icon: "💉", category: "Anesthesia & Pain" },
  { name: "Pain Rehabilitation Specialist",      icon: "💉", category: "Anesthesia & Pain" },

  // Rehabilitation & Therapy
  { name: "Physical Medicine & Rehabilitation Specialist", icon: "🤸", category: "Rehabilitation & Therapy" },
  { name: "Physiotherapist",                     icon: "🤸", category: "Rehabilitation & Therapy" },
  { name: "Occupational Therapist",              icon: "🤸", category: "Rehabilitation & Therapy" },
  { name: "Speech Therapist",                    icon: "🤸", category: "Rehabilitation & Therapy" },
  { name: "Rehabilitation Medicine Specialist",  icon: "🤸", category: "Rehabilitation & Therapy" },

  // Geriatric & Special Care
  { name: "Geriatrician",                        icon: "👴", category: "Geriatric & Special Care" },
  { name: "Palliative Care Specialist",          icon: "👴", category: "Geriatric & Special Care" },
  { name: "Hospice Care Specialist",             icon: "👴", category: "Geriatric & Special Care" },
  { name: "Long-Term Care Specialist",           icon: "👴", category: "Geriatric & Special Care" },

  // Immunology & Allergy
  { name: "Immunologist",                        icon: "🧬", category: "Immunology & Allergy" },
  { name: "Allergist",                           icon: "🧬", category: "Immunology & Allergy" },
  { name: "Clinical Immunologist",               icon: "🧬", category: "Immunology & Allergy" },
  { name: "Transfusion Medicine Specialist",     icon: "🧬", category: "Immunology & Allergy" },

  // Genetics & Molecular Medicine
  { name: "Medical Geneticist",                  icon: "🧬", category: "Genetics & Molecular Medicine" },
  { name: "Cytogeneticist",                      icon: "🧬", category: "Genetics & Molecular Medicine" },
  { name: "Molecular Geneticist",                icon: "🧬", category: "Genetics & Molecular Medicine" },
  { name: "Genomic Medicine Specialist",         icon: "🧬", category: "Genetics & Molecular Medicine" },
  { name: "Genetic Counseling Specialist",       icon: "🧬", category: "Genetics & Molecular Medicine" },
  { name: "Precision Medicine Specialist",       icon: "🧬", category: "Genetics & Molecular Medicine" },
  { name: "Regenerative Medicine Specialist",    icon: "🧬", category: "Genetics & Molecular Medicine" },
  { name: "Stem Cell Therapy Specialist",        icon: "🧬", category: "Genetics & Molecular Medicine" },

  // Lab & Research Medicine
  { name: "Clinical Microbiologist",             icon: "🧪", category: "Lab & Research Medicine" },
  { name: "Virologist",                          icon: "🧪", category: "Lab & Research Medicine" },
  { name: "Parasitologist",                      icon: "🧪", category: "Lab & Research Medicine" },
  { name: "Bacteriologist",                      icon: "🧪", category: "Lab & Research Medicine" },
  { name: "Clinical Pharmacologist",             icon: "🧪", category: "Lab & Research Medicine" },
  { name: "Toxicologist",                        icon: "🧪", category: "Lab & Research Medicine" },

  // Public Health
  { name: "Epidemiologist",                      icon: "🌍", category: "Public Health" },
  { name: "Public Health Specialist",            icon: "🌍", category: "Public Health" },
  { name: "Tropical Medicine Specialist",        icon: "🌍", category: "Public Health" },
  { name: "Global Health Specialist",            icon: "🌍", category: "Public Health" },

  // Men's & Sexual Health
  { name: "Men's Health Specialist",             icon: "🧑", category: "Men's & Sexual Health" },
  { name: "Sexual Health Specialist",            icon: "🧑", category: "Men's & Sexual Health" },
  { name: "Reproductive Medicine Specialist",    icon: "🧑", category: "Men's & Sexual Health" },

  // Nutrition & Lifestyle
  { name: "Clinical Nutritionist",               icon: "🥗", category: "Nutrition & Lifestyle" },
  { name: "Nutrition Medicine Specialist",       icon: "🥗", category: "Nutrition & Lifestyle" },
  { name: "Lifestyle Medicine Specialist",       icon: "🥗", category: "Nutrition & Lifestyle" },
  { name: "Integrative Medicine Specialist",     icon: "🥗", category: "Nutrition & Lifestyle" },
  { name: "Functional Medicine Specialist",      icon: "🥗", category: "Nutrition & Lifestyle" },

  // Specialised Medicine
  { name: "Forensic Medicine Specialist",        icon: "⚕️", category: "Specialised Medicine" },
  { name: "Aviation Medicine Specialist",        icon: "⚕️", category: "Specialised Medicine" },
  { name: "Aerospace Medicine Specialist",       icon: "⚕️", category: "Specialised Medicine" },
  { name: "Diving Medicine Specialist",          icon: "⚕️", category: "Specialised Medicine" },
  { name: "Hyperbaric Medicine Specialist",      icon: "⚕️", category: "Specialised Medicine" },
  { name: "Wilderness Medicine Specialist",      icon: "⚕️", category: "Specialised Medicine" },
  { name: "Military Medicine Specialist",        icon: "⚕️", category: "Specialised Medicine" },
  { name: "Disaster Medicine Specialist",        icon: "⚕️", category: "Specialised Medicine" },
  { name: "Space Medicine Specialist",           icon: "⚕️", category: "Specialised Medicine" },
  { name: "Environmental Medicine Specialist",   icon: "⚕️", category: "Specialised Medicine" },
  { name: "Occupational Medicine Specialist",    icon: "⚕️", category: "Specialised Medicine" },
  { name: "Travel Medicine Specialist",          icon: "⚕️", category: "Specialised Medicine" },
  { name: "Trauma Medicine Specialist",          icon: "⚕️", category: "Specialised Medicine" },

  // Emerging Fields
  { name: "Telemedicine Specialist",             icon: "🌐", category: "Emerging Fields" },

  // Traditional Medicine
  { name: "Ayurveda",                            icon: "🌿", category: "Traditional Medicine" },
  { name: "Homeopathy",                          icon: "💊", category: "Traditional Medicine" },

  // Dentistry
  { name: "Dentist",                             icon: "🦷", category: "Dentistry" },
];

// ── Category display config ───────────────────────────────────────────────────
const CATEGORY_ORDER = [
  "General & Primary Care", "Heart & Blood", "Brain & Nervous System",
  "Bones & Muscles", "Child Health", "Women's Health", "Eye Care",
  "Ear, Nose & Throat", "Chest & Respiratory", "Digestive System",
  "Hormones & Metabolism", "Skin & Cosmetic", "Cancer & Blood",
  "Mental Health", "Kidney & Urinary", "Diagnostic & Imaging",
  "Surgical Specialties", "Anesthesia & Pain", "Rehabilitation & Therapy",
  "Geriatric & Special Care", "Immunology & Allergy",
  "Genetics & Molecular Medicine", "Lab & Research Medicine",
  "Public Health", "Men's & Sexual Health", "Nutrition & Lifestyle",
  "Specialised Medicine", "Emerging Fields", "Traditional Medicine", "Dentistry",
];

const CATEGORY_ICONS = {
  "General & Primary Care":        "🩺",
  "Heart & Blood":                 "❤️",
  "Brain & Nervous System":        "🧠",
  "Bones & Muscles":               "🦴",
  "Child Health":                  "👶",
  "Women's Health":                "🌸",
  "Eye Care":                      "👁️",
  "Ear, Nose & Throat":            "👂",
  "Chest & Respiratory":           "🫁",
  "Digestive System":              "🍽️",
  "Hormones & Metabolism":         "⚗️",
  "Skin & Cosmetic":               "🌿",
  "Cancer & Blood":                "🎗️",
  "Mental Health":                 "🧘",
  "Kidney & Urinary":              "💧",
  "Diagnostic & Imaging":          "📡",
  "Surgical Specialties":          "🔧",
  "Anesthesia & Pain":             "💉",
  "Rehabilitation & Therapy":      "🤸",
  "Geriatric & Special Care":      "👴",
  "Immunology & Allergy":          "🧬",
  "Genetics & Molecular Medicine": "🧬",
  "Lab & Research Medicine":       "🧪",
  "Public Health":                 "🌍",
  "Men's & Sexual Health":         "🧑",
  "Nutrition & Lifestyle":         "🥗",
  "Specialised Medicine":          "⚕️",
  "Emerging Fields":               "🌐",
  "Traditional Medicine":          "🌿",
  "Dentistry":                     "🦷",
};

// ── Chip (selectable / clickable suggestion chip) ─────────────────────────────
function Chip({ icon, name, onClick }) {
  const [hovered, setHovered] = useState(false);
  return (
    <button
      onMouseDown={(e) => e.preventDefault()}
      onClick={onClick}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      style={{
        display: "inline-flex", alignItems: "center", gap: "5px",
        padding: "5px 13px",
        background: hovered ? "#0ea5e9" : "#f0f9ff",
        border: `1.5px solid ${hovered ? "#0ea5e9" : "#bae6fd"}`,
        borderRadius: "20px",
        fontSize: "12.5px", fontWeight: "700",
        color: hovered ? "#fff" : "#0369a1",
        fontFamily: "'Nunito', 'Segoe UI', sans-serif",
        cursor: "pointer", whiteSpace: "nowrap",
        transition: "all 0.15s ease",
        outline: "none", flexShrink: 0,
      }}
    >
      <span style={{ fontSize: "13px", lineHeight: 1 }}>{icon}</span>
      {name}
    </button>
  );
}

// ── SelectedChip (removable chip shown for already-picked specialities) ───────
function SelectedChip({ icon, name, onRemove }) {
  const [hovered, setHovered] = useState(false);
  return (
    <span
      style={{
        display: "inline-flex", alignItems: "center", gap: "6px",
        padding: "6px 8px 6px 12px",
        background: "#0369a1",
        borderRadius: "20px",
        fontSize: "12.5px", fontWeight: "700",
        color: "#fff",
        fontFamily: "'Nunito', 'Segoe UI', sans-serif",
        whiteSpace: "nowrap",
      }}
    >
      <span style={{ fontSize: "13px", lineHeight: 1 }}>{icon}</span>
      {name}
      <button
        type="button"
        onMouseDown={(e) => e.preventDefault()}
        onClick={onRemove}
        onMouseEnter={() => setHovered(true)}
        onMouseLeave={() => setHovered(false)}
        aria-label={`Remove ${name}`}
        style={{
          display: "flex", alignItems: "center", justifyContent: "center",
          width: 16, height: 16, borderRadius: "50%",
          border: "none", cursor: "pointer", padding: 0, lineHeight: 1,
          background: hovered ? "rgba(255,255,255,0.35)" : "rgba(255,255,255,0.18)",
          color: "#fff", fontSize: 11, fontWeight: 800,
          transition: "background 0.15s ease",
        }}
      >
        ✕
      </button>
    </span>
  );
}

// ── Dropdown content (shared) ─────────────────────────────────────────────────
function DropdownContent({ query, onChipClick, selectedSet }) {
  // Searching: flat filtered list
  if (query.length > 0) {
    const matches = SPECIALITIES.filter((s) =>
      s.name.toLowerCase().includes(query) ||
      s.category.toLowerCase().includes(query)
    );
    return (
      <>
        <p style={labelStyle}>
          {matches.length} matching specialit{matches.length === 1 ? "y" : "ies"}
        </p>
        {matches.length > 0 ? (
          <div style={{ display: "flex", flexWrap: "wrap", gap: "7px" }}>
            {matches.map((s) => (
              <Chip
                key={s.name}
                icon={s.icon}
                name={selectedSet?.has(s.name) ? `${s.name} ✓` : s.name}
                onClick={() => onChipClick(s.name)}
              />
            ))}
          </div>
        ) : (
          <p style={{ fontSize: 12, color: "#9CA3AF", margin: 0 }}>No matching speciality found</p>
        )}
      </>
    );
  }

  // Not searching: grouped by category
  return (
    <>
      <p style={labelStyle}>Browse by speciality</p>
      <div style={{ display: "flex", flexDirection: "column", gap: "14px" }}>
        {CATEGORY_ORDER.map((cat) => {
          const items = SPECIALITIES.filter((s) => s.category === cat);
          if (!items.length) return null;
          return (
            <div key={cat}>
              <p style={catLabelStyle}>
                {CATEGORY_ICONS[cat]} {cat}
              </p>
              <div style={{ display: "flex", flexWrap: "wrap", gap: "6px" }}>
                {items.map((s) => (
                  <Chip
                    key={s.name}
                    icon={s.icon}
                    name={selectedSet?.has(s.name) ? `${s.name} ✓` : s.name}
                    onClick={() => onChipClick(s.name)}
                  />
                ))}
              </div>
            </div>
          );
        })}
      </div>
    </>
  );
}

const labelStyle = {
  margin: "0 0 8px 2px", fontSize: "10px", fontWeight: "800",
  color: "#94a3b8", letterSpacing: "0.7px", textTransform: "uppercase",
  fontFamily: "'Nunito', sans-serif",
};

const catLabelStyle = {
  margin: "0 0 6px 0", fontSize: "11px", fontWeight: "800",
  color: "#0369a1", letterSpacing: "0.4px",
  fontFamily: "'Nunito', sans-serif",
};

// ── Universal SpecialityAutosuggest ───────────────────────────────────────────
//
//  MODE A — Single Form Field (no `onSelect`, no `multi`) — UNCHANGED
//    <SpecialityAutosuggest
//      value={someString}
//      onChange={(val) => ...}      ← receives plain STRING
//    />
//
//  MODE B — Search Bar (`onSelect` prop present) — UNCHANGED
//    <SpecialityAutosuggest
//      value={searchQuery}
//      onChange={handleChangeEvent} ← receives DOM event
//      onSelect={(name) => ...}     ← chip click
//      onSearch={() => doSearch()}  ← Enter key
//    />
//
//  MODE C — Multi-select Form Field (`multi` prop is true) — NEW
//    <SpecialityAutosuggest
//      multi
//      value={doctorData.Speciality}        ← ARRAY of strings, e.g. []
//      onChange={(arr) => setDoctorData(prev => ({ ...prev, Speciality: arr }))}
//    />
//    - Dropdown to browse/search specialities, click a chip to stage it
//    - Typed free text can also be staged (custom speciality)
//    - "Add" button confirms the staged pick and adds it to the array
//    - Selected specialities show below as removable chips
//    - onChange always receives the full updated ARRAY
// ─────────────────────────────────────────────────────────────────────────────
export default function SpecialityAutosuggest({
  value, onChange, onSelect, onSearch, placeholder, multi = false,
}) {
  const [focused, setFocused] = useState(false);
  const inputRef = useRef(null);

  // Hooks for MODE C (multi-select) — declared unconditionally at top level
  // so hook order never changes between renders, even though they're only
  // used when `multi` is true. See Rules of Hooks.
  const [draft, setDraft] = useState("");
  const draftRef = useRef(null);

  const isSearchBar = typeof onSelect === "function";

  // ── MODE C: Multi-select ────────────────────────────────────────────────
  if (multi && !isSearchBar) {
    const selected = Array.isArray(value) ? value : [];
    const selectedSet = new Set(selected.map((s) => s.toLowerCase()));
    const query = draft.trim().toLowerCase();

    const addSpeciality = (name) => {
      const trimmed = (name || "").trim();
      if (!trimmed) return;
      const alreadyAdded = selected.some((s) => s.toLowerCase() === trimmed.toLowerCase());
      if (alreadyAdded) {
        // De-select on repeat click of an already-added chip
        onChange(selected.filter((s) => s.toLowerCase() !== trimmed.toLowerCase()));
      } else {
        onChange([...selected, trimmed]);
      }
      setDraft("");
      draftRef.current?.focus();
    };

    const handleAddClick = () => addSpeciality(draft);

    const removeSpeciality = (name) => {
      onChange(selected.filter((s) => s !== name));
    };

    const handleKeyDown = (e) => {
      if (e.key === "Enter") { e.preventDefault(); addSpeciality(draft); }
      if (e.key === "Escape") { setFocused(false); draftRef.current?.blur(); }
    };

    const findIcon = (name) => {
      const match = SPECIALITIES.find((s) => s.name.toLowerCase() === name.toLowerCase());
      return match?.icon || "⚕️";
    };

    return (
      <div style={{ marginBottom: 14, position: "relative" }}>
        <label style={{ display: "block", fontSize: 13, fontWeight: 600, color: "#374151", marginBottom: 6 }}>
          Speciality <span style={{ color: "#EF4444" }}>*</span>
          {selected.length > 0 && (
            <span style={{ marginLeft: 6, fontSize: 11, fontWeight: 600, color: "#0369a1" }}>
              ({selected.length} selected)
            </span>
          )}
        </label>

        <div style={{ display: "flex", gap: 8 }}>
          <input
            ref={draftRef}
            type="text"
            value={draft}
            onChange={(e) => setDraft(e.target.value)}
            onFocus={(e) => {
              setFocused(true);
              e.target.style.borderColor = "#06B6D4";
              e.target.style.boxShadow = "0 0 0 3px rgba(6,182,212,0.15)";
            }}
            onBlur={(e) => {
              setTimeout(() => setFocused(false), 180);
              e.target.style.borderColor = "#E5E7EB";
              e.target.style.boxShadow = "none";
            }}
            onKeyDown={handleKeyDown}
            placeholder={placeholder || "Search or type a speciality..."}
            autoComplete="off"
            style={{
              flex: 1, padding: "12px 14px",
              border: "2px solid #E5E7EB", borderRadius: 9,
              fontSize: 16, outline: "none",
              transition: "border-color 0.2s, box-shadow 0.2s",
              WebkitAppearance: "none", boxSizing: "border-box",
            }}
          />
          <button
            type="button"
            onMouseDown={(e) => e.preventDefault()}
            onClick={handleAddClick}
            disabled={!draft.trim()}
            style={{
              padding: "0 18px",
              border: "none", borderRadius: 9,
              background: draft.trim() ? "#06B6D4" : "#E5E7EB",
              color: draft.trim() ? "#fff" : "#9CA3AF",
              fontWeight: 700, fontSize: 14,
              cursor: draft.trim() ? "pointer" : "not-allowed",
              minWidth: 64, flexShrink: 0,
              transition: "background 0.15s ease",
            }}
          >
            Add
          </button>
        </div>

        {focused && (
          <div
            onMouseDown={(e) => e.preventDefault()}
            style={{
              position: "absolute", top: "calc(100% + 4px)", left: 0, right: 0,
              zIndex: 9999, background: "white",
              border: "1.5px solid #bae6fd", borderRadius: 12,
              padding: "12px", boxShadow: "0 8px 32px rgba(0,0,0,0.14)",
              maxHeight: 340, overflowY: "auto",
            }}
          >
            <DropdownContent query={query} onChipClick={addSpeciality} selectedSet={selectedSet} />
          </div>
        )}

        {selected.length > 0 ? (
          <div style={{ display: "flex", flexWrap: "wrap", gap: "8px", marginTop: 10 }}>
            {selected.map((name) => (
              <SelectedChip
                key={name}
                icon={findIcon(name)}
                name={name}
                onRemove={() => removeSpeciality(name)}
              />
            ))}
          </div>
        ) : (
          <p style={{ fontSize: 12, color: "#9CA3AF", margin: "8px 0 0" }}>
            No specialities added yet. Search above, click a match, or type your own and hit Add.
          </p>
        )}
      </div>
    );
  }

  // ── MODE A / B: existing single-value behaviour (unchanged) ───────────────
  const safeValue = typeof value === "string" ? value : String(value ?? "");
  const query      = safeValue.trim().toLowerCase();

  const handleInputChange = (e) => {
    isSearchBar ? onChange(e) : onChange(e.target.value);
  };

  const handleChipClick = (name) => {
    isSearchBar ? onSelect(name) : onChange(name);
    inputRef.current?.focus();
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter")  { e.preventDefault(); setFocused(false); inputRef.current?.blur(); onSearch?.(); }
    if (e.key === "Escape") { setFocused(false); inputRef.current?.blur(); }
  };

  const Dropdown = () => (
    <div
      onMouseDown={(e) => e.preventDefault()}
      style={{
        position: "absolute",
        top: isSearchBar ? "calc(100% + 12px)" : "calc(100% + 4px)",
        left: isSearchBar ? "-14px" : 0,
        right: isSearchBar ? "-14px" : 0,
        zIndex: 9999,
        background: "white",
        border: "1.5px solid #bae6fd",
        borderRadius: 12,
        padding: "12px",
        boxShadow: "0 8px 32px rgba(0,0,0,0.14)",
        maxHeight: 340,
        overflowY: "auto",
      }}
    >
      <DropdownContent query={query} onChipClick={handleChipClick} />
    </div>
  );

  // ── MODE A: Form Field ─────────────────────────────────────────────────────
  if (!isSearchBar) {
    return (
      <div style={{ marginBottom: 14, position: "relative" }}>
        <label style={{ display: "block", fontSize: 13, fontWeight: 600, color: "#374151", marginBottom: 6 }}>
          Speciality <span style={{ color: "#EF4444" }}>*</span>
        </label>
        <input
          ref={inputRef}
          type="text"
          value={safeValue}
          onChange={handleInputChange}
          onFocus={(e) => {
            setFocused(true);
            e.target.style.borderColor = "#06B6D4";
            e.target.style.boxShadow = "0 0 0 3px rgba(6,182,212,0.15)";
          }}
          onBlur={(e) => {
            setTimeout(() => setFocused(false), 180);
            e.target.style.borderColor = "#E5E7EB";
            e.target.style.boxShadow = "none";
          }}
          onKeyDown={handleKeyDown}
          placeholder={placeholder || "Type or pick a speciality"}
          autoComplete="off"
          style={{
            width: "100%", padding: "12px 14px",
            border: "2px solid #E5E7EB", borderRadius: 9,
            fontSize: 16, outline: "none",
            transition: "border-color 0.2s, box-shadow 0.2s",
            WebkitAppearance: "none", boxSizing: "border-box",
          }}
        />
        {focused && <Dropdown />}
      </div>
    );
  }

  // ── MODE B: Search Bar ─────────────────────────────────────────────────────
  return (
    <div style={{ flex: 1, minWidth: 0, position: "relative", alignSelf: "stretch", display: "flex", alignItems: "center" }}>
      <input
        ref={inputRef}
        type="text"
        value={safeValue}
        onChange={handleInputChange}
        onFocus={() => setFocused(true)}
        onBlur={() => setTimeout(() => setFocused(false), 180)}
        onKeyDown={handleKeyDown}
        placeholder={placeholder || "Search by doctor name, clinic, speciality or address..."}
        autoComplete="off"
        style={{
          flex: 1, width: "100%", minWidth: 0,
          height: "42px", border: "none", background: "transparent",
          outline: "none", fontSize: "14px",
          fontFamily: "'Nunito', 'Segoe UI', sans-serif",
          color: "#0c4a6e", fontWeight: "600",
          padding: "0 8px", boxSizing: "border-box",
        }}
      />
      {focused && <Dropdown />}
    </div>
  );
}